/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BooleanApiResponse } from '../../models/boolean-api-response';
import { CheckAccessCommand } from '../../models/check-access-command';

export interface CheckMasterAccessAsync$Params {
  command?: CheckAccessCommand;
}

export function checkMasterAccessAsync(http: HttpClient, rootUrl: string, params?: CheckMasterAccessAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanApiResponse>> {
  const rb = new RequestBuilder(rootUrl, checkMasterAccessAsync.PATH, 'get');
  if (params) {
    rb.query('command', params.command, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BooleanApiResponse>;
    })
  );
}

checkMasterAccessAsync.PATH = '/api/access/master';
